import EFPicture from '@elem/ui/ef-picture';
import styles from './index.module.scss';

const GIFT_TYPE_MAP = {
    OFF: 1,
    PRODUCT: 2,
    CASH: 3,
};

export default function Gift(props: { type: number; amount: number; className?: string }) {
    const { type, amount, className } = props;

    return (
        <div className={`${styles.Gift} ${className}`}>
            {type === GIFT_TYPE_MAP.OFF && (
                <div className={`prize-ticket-inner`}>
                    <div className={`prize-ticket-inner-amount prize-ticket-inner-amount-off`}>
                        <span className="prize-ticket-inner-amount-amount">{amount}%</span>
                        <span className="prize-ticket-inner-amount-text">OFF</span>
                    </div>
                    <EFPicture src="https://websiteoss.ecoflow.com/figma-uploads/1775095658689-a2vg3q-compressed-Frame%202094654981.png" />
                </div>
            )}
            {type === GIFT_TYPE_MAP.CASH && (
                <div className={`prize-ticket-inner`}>
                    <div className={`prize-ticket-inner-amount prize-ticket-inner-amount-cash`}>
                        <span className="prize-ticket-inner-amount-currency">$</span>
                        <span className="prize-ticket-inner-amount-amount">{amount}</span>
                    </div>
                    <EFPicture src="https://websiteoss.ecoflow.com/figma-uploads/1775095027461-yu5t6l-compressed-Frame%202094654983.png" />
                </div>
            )}
            {type === GIFT_TYPE_MAP.PRODUCT && (
                <EFPicture src="https://websiteoss.ecoflow.com/figma-uploads/1775095672152-4fnbkt-compressed-RAPID%20Pro%2010k%201.png" />
            )}
        </div>
    );
}
